import React, { useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';

function MessageInput({ onSend }) {
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!text.trim()) return;
    setLoading(true);
    await onSend(text);
    setText('');
    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSend();
  };

  return (
    <InputGroup>
      <Form.Control
        placeholder="پیام خود را وارد کنید..."
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={loading}
      />
      <Button
        variant="info"
        onClick={handleSend}
        disabled={loading}
        style={{
          opacity: loading ? 0.5 : 1,
          transition: 'opacity 0.3s',
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = '#00aaff')}
        onMouseLeave={(e) => (e.target.style.backgroundColor = '')}
      >
        {loading ? '...' : 'ارسال'}
      </Button>
    </InputGroup>
  );
}

export default MessageInput;
